import { Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import MainLayout from "../../../layouts/MainLayout";
import DefaultButton from "../../../components/Buttons/Default";
import { useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";

function PasswordNewPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");

  const resetPassword = () => {
    setIsLoading(true);

    fetch(`${API_URL}/password/reset`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        phone_number: location?.state?.phoneNumber,
        otp: location?.state?.otp,
        new_password: newPassword
      }),
    })
    .then(response => response.json())
    .then(data => {
      setIsLoading(false);
      if (data.success) {
        toast.success("تم تعيين كلمة المرور بنجاح");
        navigate('/login');
      } else {
        toast.error(data.message || "حدث خطأ أثناء تعيين كلمة المرور");
      }
    })
    .catch(error => {
      setIsLoading(false);
      toast.error("حدث خطأ أثناء تعيين كلمة المرور");
    });
  }

  return(
    <MainLayout>
      <section className="auth-section py-5">
        <Container>
          <Row>
            <Col lg="5" md="6" className="mx-auto">
              <div className="text-center">
                <img
                  src={require("../../../assets/images/logo.png")}
                  height={60}
                  alt="Logo"
                />
              </div>

              <h3 className="text-center mb-3 mt-5 text-primary fw-normal">
                تعيين كلمة مرور جديدة
              </h3>
              <p className="text-center mb-4">
                ادخل كلمة المرور الجديدة
              </p>

              <div className="bg-white auth-form-container px-4 py-5">
                <FormGroup>
                  <Label>كلمة المرور الجديدة: </Label>
                  <Input 
                    type="password" 
                    placeholder="أدخل كلمة المرور الجديدة" 
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>تأكيد كلمة المرور: </Label>
                  <Input 
                    type="password" 
                    placeholder="أعد إدخال كلمة المرور الجديدة" 
                    value={newPasswordConfirmation}
                    onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                  />
                </FormGroup>
                <div className="text-center">
                  <DefaultButton 
                    color="primary" 
                    className="px-5"
                    disabled={isLoading || newPassword.length < 8 || newPassword !== newPasswordConfirmation}
                    loading={isLoading}
                    onClick={resetPassword}
                  >
                    تعيين كلمة المرور
                  </DefaultButton>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default PasswordNewPasswordPage;